import React, { useEffect, useState } from "react";

import { BackdropSection, SuccessTransaction, WalletIcon } from "components";
import { walletFiatProps } from "utils/constants";
import PopupContent from "./components/PopupContent";
import { useDisableTransactionCompleted } from "api";
import LeftContent from "./components/LeftContent";
import RightContent from "./components/RightContent";
import { useSelector } from "react-redux";

export default function WalletContent() {
  const [openIsSubmitted, setIsSubmitted] = useState(false);
  const [pageDelay, setPageDelay] = useState(false);

  const {
    walletStatus: { currentWallet },
  } = useSelector((state) => state.utils);

  const cWProp = walletFiatProps.find((i) => i?.id === currentWallet);

  useEffect(() => {
    setTimeout(() => {
      setPageDelay(true);
    }, 500);
    setPageDelay(false);
  }, [currentWallet]);

  useDisableTransactionCompleted(setIsSubmitted);

  return (
    <>
      {cWProp && (
        <div className="relative flex-1">
          <div className="h-full">
            <div className="flex h-[60px] items-center border-b border-slate-100 p-4">
              <div className="flex-1">
                <div className="flex items-center">
                  <WalletIcon
                    type={cWProp.id}
                    color={cWProp.iconColor}
                    sym={cWProp.symUnit}
                    fontSize="small"
                  />
                  <h5 className="ml-2 font-bold">{cWProp.name}</h5>
                </div>
              </div>
            </div>

            <div className="h-full">
              {/*   */}
              <div className="grid h-full grid-cols-10">
                <LeftContent />
                <RightContent />
              </div>
            </div>
          </div>
          <PopupContent />

          <BackdropSection open={!pageDelay} />
        </div>
      )}
      {openIsSubmitted && (
        <SuccessTransaction open={openIsSubmitted} setOpen={setIsSubmitted} />
      )}
    </>
  );
}
